import { useCallback, useEffect, useState } from 'react';
import RealTime from './RealTime';
import { GetHistorical } from '../../Api/getData.jsx';
import dayjs from 'dayjs';
import HistoryRangeDate from './HistoryRangeDate';
import HistoryByTrip from './HistoryByTrip';
import SPAL from './SPAL';
import { useDataFilter } from '../../components/global.jsx';
import { useSearchParams } from 'react-router-dom';
import FilterBucker from './components/FilterBuncker.jsx';
import WaterLevel from './components/Chart/WaterLevel.jsx';
import AnalyticsPanel from './components/AnalyticsPanel';
import './analytics.css';
import { HiChartBar } from 'react-icons/hi';
import { TbChartBar, TbCalendarStats, TbRoute, TbFileAnalytics, TbGasStation } from 'react-icons/tb';

const StartRange = () => dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss.SSS');
const EndRange = () => dayjs().format('YYYY-MM-DD HH:mm:ss');

const BUNKER_CARDS = [
    { key: 'BeginingStock', title: 'Start Stock' },
    { key: 'EndingStock', title: 'Finish Stock' },
    { key: 'BBM_IN', title: 'Filling' },
    { key: 'BBM_OUT', title: 'Consumption' },
];

const Analityc = () => {

    useEffect(() => {
        document.title = "NextSense - Analityc";
    }, []);

    useDataFilter();

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") || "SGM";
    const ShipCode = searchParams.get("ShipCode") || "G2008";

    const [ToleransiFill] = useState("120");
    const [ToleransiGuncangan] = useState("120");
    const dataToleransi = [ToleransiFill, ToleransiGuncangan];

    const [data, setData] = useState([]);
    const [dataBunker, setDataBunker] = useState([]);

    const handleBunkerData = useCallback((values) => setDataBunker(values), []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await GetHistorical(
                    KodeCabang,
                    ShipCode,
                    StartRange(),
                    EndRange(),
                    ToleransiFill,
                    ToleransiGuncangan
                );
                setData(response);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [KodeCabang, ShipCode, ToleransiFill, ToleransiGuncangan]);

    return (
        <main className="analytics-page">
            <header className="analytics-header">
                <span className="analytics-page-icon"><HiChartBar /></span>
                <div><h1>Analytics Dashboard</h1><p>Advanced vessel, voyage, and bunker analytics</p></div>
            </header>
            <div className="analytics-grid">
                <AnalyticsPanel icon={TbChartBar} title="Real-Time Analysis" subtitle="Filling and consumption totals for the displayed SPAL period">
                    <RealTime onDataToleransi={dataToleransi} />
                </AnalyticsPanel>
                <AnalyticsPanel icon={TbCalendarStats} title="Date Range Analysis" subtitle="Fuel totals within the selected date range">
                    <HistoryRangeDate dataSource={data} onDataToleransi={dataToleransi} />
                </AnalyticsPanel>
                <AnalyticsPanel icon={TbRoute} title="Trip Analysis" subtitle="Fuel totals for the selected voyage">
                    <HistoryByTrip onDataToleransi={dataToleransi} />
                </AnalyticsPanel>
                <AnalyticsPanel icon={TbFileAnalytics} title="SPAL Analysis" subtitle="Fuel totals between selected activities">
                    <SPAL onDataToleransi={dataToleransi} />
                </AnalyticsPanel>
            </div>
            <AnalyticsPanel icon={TbGasStation} title="Bunker History" subtitle="Stock and fuel totals for the selected period">
                <FilterBucker onData={handleBunkerData} />
                <div className="analytics-metrics analytics-stock">
                    {BUNKER_CARDS.map(({ key, title }) => <WaterLevel key={key} dataSource={dataBunker?.[key]} title={title} />)}
                </div>
            </AnalyticsPanel>
        </main>
    );
};

export default Analityc;
